import { AppType } from "@azm/core/enums/app-types";
import { EnvironmentMode } from "@azm/core/enums/environment-mode";
import { createEnvironment } from "./environment.shared";

export const environment = createEnvironment({
	production: false,
	mode: EnvironmentMode.Staging,
	appType: AppType.Internal,
	apiBaseUrl: "https://stgcx.sba.gov.sa/int/",
	enableAiTextAssist: true,
});
